import { AnyAction } from "redux";
import { SET_ROLE_CLIENTS_LOADED } from "../actions/loadingRoleClients";

export const loadingRoleClients = (state = false, action: AnyAction) => {
  switch (action.type) {
    case SET_ROLE_CLIENTS_LOADED:
      return action.roleClientsLoaded;
    default:
      return state;
  }
};

export default loadingRoleClients;
